<div class="max-w-sm mx-auto bg-white p-4 grid gap-4">

  <h2 class="text-gray-700 font-semibold text-lg text-center">
    {{ title || "Retention (Reels)" }}
  </h2>

  <div class="relative w-full h-64">
    <apx-chart [series]="chartOptions.series" [chart]="chartOptions.chart" [labels]="chartOptions.labels"
      [plotOptions]="chartOptions.plotOptions" [dataLabels]="chartOptions.dataLabels" [fill]="chartOptions.fill"
      [legend]="chartOptions.legend">
    </apx-chart>

    <div class="absolute inset-0 grid place-items-center pointer-events-none text-center">
      <div>
        <span class="text-3xl font-bold text-gray-800 block">{{ percent }}%</span>
        <span class="text-xs text-gray-500 block mt-1">{{ avgWatch }}</span>
      </div>
    </div>
  </div>

  <div class="grid grid-cols-2 gap-2 justify-items-center">
    <div class="bg-gray-100 rounded px-2 py-1 text-xs font-medium text-gray-700">
      {{ avgLength }}
    </div>

  </div>

</div>